<p-popover #menu (onHide)="activeRowId.set(null)">
  <div class="pef-progressive-form">
    <div class="pef-progressive-title">Riempimento progressivo</div>

    <div class="pef-progressive-field">
      <span class="pef-progressive-label">Anno iniziale</span>
      <p-select
        [autofocus]="false"
        [options]="rowColumns()"
        [(ngModel)]="startColumnId"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
      />
    </div>

    <div class="pef-progressive-field">
      <span class="pef-progressive-label">Intervallo</span>
      <p-inputnumber
        [autofocus]="false"
        [(ngModel)]="interval"
        [min]="1"
        [step]="1"
        [showButtons]="true"
        [minFractionDigits]="0"
        [maxFractionDigits]="0"
        suffix=" anni"
      />
    </div>

    <div class="pef-progressive-field">
      <span class="pef-progressive-label">Incremento</span>
      <p-inputnumber
        [autofocus]="false"
        [(ngModel)]="increment"
        [minFractionDigits]="0"
        [maxFractionDigits]="2"
        [useGrouping]="true"
        placeholder="es. 5"
      />
    </div>

    <div class="pef-progressive-field">
      <span class="pef-progressive-label">Tipo</span>
      <p-select
        [autofocus]="false"
        [options]="modeOptions"
        [(ngModel)]="mode"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
      />
    </div>

    <button
      class="pef-progressive-apply"
      [disabled]="increment() === null"
      (click)="onApply()"
    >
      Applica
    </button>
  </div>
</p-popover>
